export class MissingPantoneColorsError extends Error {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "message", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "Pantone colors are missing"
    });
  }
}